export enum LLM {
  auto = 'auto',
  gemini2_5_flash = 'gemini-2.5-flash',
  qwen2_5_14B_1M = 'qwen2_5-14B_instruct_1M',
}
